import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import loaderimage from "../../images/giphy.gif";

const CandidateDetails = () => {
  const { id } = useParams(); 
  const [candidate, setCandidate] = useState<any>([]);
  const [error, setError] = useState<any>('');
  const [loading, setLoading] = useState(true);
  const ApiUrl = process.env.REACT_APP_API_URL 
  useEffect(() => {
    const fetchCandidateDetails = async () => {
      try {
        const url = process.env.REACT_APP_API_URL + `candidate_details/byuserid/${id}`
        const response = await axios.get(url);
        setCandidate(response.data[0]); 
        setError(null);
      } catch (err) {
        setError("Failed to fetch candidate details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchCandidateDetails();
  }, [id]);

  if (loading) {
    return <div><img src={loaderimage} alt="Loading..." height="40" /></div>;
  }

  if (error) {
    return <div className="text-danger">{error}</div>;
  }

  if (!candidate) {
    return <div>No candidate details found.</div>;
  }

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1 className="text-primary">{candidate.name}</h1>
              <h5 className="text-muted">{candidate.currentDesignation}</h5>
            </div>
            <div>
              <a
                href={candidate.linkedinid}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-primary me-2"
              >
                <i className="fa-brands fa-linkedin me-1"></i> LinkedIn
              </a>
              {candidate.githubid && (
                <a
                  href={candidate.githubid}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-secondary"
                >
                  <i className="fa-brands fa-github me-1"></i> GitHub
                </a>
              )}
            </div>
          </div>

          <div className="text-center mb-4">
            <img
              src={ApiUrl+candidate.profilepicture}
              alt="Profile"
              className="img-fluid rounded-circle mb-3"
              style={{ maxWidth: "150px" }}
            />
            <h5 className="text-primary">{candidate.name}</h5>
            <p>{candidate.email}</p>
            <p>{candidate.mobile}</p>
          </div>

          <hr />
          <div className="mb-4">
            <h4 className="text-primary">Contact Details</h4>
            <p>
              <strong>Email:</strong> {candidate.email} <br />
              <strong>Phone:</strong> {candidate.mobile} <br />
              <strong>WhatsApp:</strong> {candidate.whatsapp_mobile}
            </p>
            <hr />
          </div>

          <div className="mb-4">
            <h4 className="text-primary">Summary</h4>
            <p>{candidate.bio}</p>
            <hr />
          </div>

          <div className="mb-4">
            <h4 className="text-primary">Education</h4>
            <p>
              <strong>{candidate.college}</strong> in {candidate.branch},{" "}
              {candidate.university} ({candidate.passing_year})
            </p>
            <hr />
          </div>
          <div className="mb-4">
            <h4 className="text-primary">Skills</h4>
            <div className="d-flex flex-wrap gap-2">
              {candidate.skills ? (() => {
                let skillsArray = [];

                if (typeof candidate.skills === "string") {
                  try {
                    const parsed = JSON.parse(candidate.skills);
                    skillsArray = Array.isArray(parsed) ? parsed : [];
                  } catch (err) {
                    return <p>Invalid skill data</p>;
                  }
                } else if (Array.isArray(candidate.skills)) {
                  skillsArray = candidate.skills;
                }

                return skillsArray.length > 0 ? (
                  skillsArray.map((skill: any) => (
                    <button
                      key={skill.skill_id}
                      type="button"
                      className="btn btn-outline-primary btn-sm m-2"
                    >
                      {skill.skill_name}
                    </button>
                  ))
                ) : (
                  <p>No skills specified</p>
                );
              })() : (
                <p>No skills specified</p>
              )}
            </div>
            <hr />
          </div>

          <div className="mb-4">
            <h4 className="text-primary">Work Experience</h4>
            <p>
              <strong>{candidate.currentcompany}</strong> -{" "}
              {candidate.currentDesignation} <br />
              <span className="text-muted">
                Duration: {candidate.yearsOfExperience} years | Location:{" "}
                {candidate.workLocation}
              </span>
              <br />
              <span className="text-muted">Notice Period: {candidate.noticePeriod} months</span>
            </p>
            <hr />
          </div>

          <div className="mb-4">
            <h4 className="text-primary mb-3">Additional Information</h4>
            <p>
              <strong>Date of Birth:</strong> {new Date(candidate.dob).toLocaleDateString()}{" "}
              <br />
              <strong>Known Languages:</strong> {candidate.language} <br />
              <strong>Country:</strong> {candidate.country_name} <br />
              <strong>State:</strong> {candidate.state_name} <br />
              <strong>City:</strong> {candidate.city_name} <br />
              <strong>Address:</strong> {candidate.address} <br />
              <strong>Postal Code:</strong> {candidate.post_code}
            </p>
            <hr />
          </div>

          <div className="mb-4">
            <h4 className="text-primary">CV</h4>
            <a
              href={candidate.uploadCV}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-success"
            >
              Download CV
            </a>
          </div>
          <div>
            <Link to="/candidate_details" type="button" className="btn btn-danger" >
              Go Back
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateDetails;
